import type { VFC } from 'react';

import { selectOptionFactory } from '../../../utils';
import FilterCardMultiSelect from '../../generic/Filter/FilterCardMultiSelect';
import FilterPanel from '../../generic/Filter/FilterPanel';
import IgnoreReasonTitle from '../../shared/vulns/IgnoreReasonTitle';
import type { SelectOption } from '../../../types';

type Props = {
  descriptions: Record<string, string>;
  testId: string;
  onSet(values: string[]): void;
  selectedOptions?: string[];
};

/**
 * Add a dropdown of checkboxes for filtering ignored issues by ignore reason.
 * Shared between the vuln and licensing categories, each supplying its own
 * set of reason descriptions.
 */
const IgnoreReasonFilter: VFC<Props> = ({ descriptions, testId, selectedOptions, onSet }) => {
  const options = Object.entries(descriptions).map(([ignoreReason, label]) => {
    return selectOptionFactory(ignoreReason, label);
  });

  const selectedOptionsDropdownValues = (selectedOptions || []).reduce((acc, ignoreReason) => {
    if (descriptions[ignoreReason]) {
      acc.push(selectOptionFactory(ignoreReason, descriptions[ignoreReason]));
    }
    return acc;
  }, [] as SelectOption[]);

  return (
    <FilterPanel>
      <FilterCardMultiSelect
        label={<IgnoreReasonTitle title="Ignore Reason" />}
        placeholder="Select one or more..."
        options={options}
        values={selectedOptionsDropdownValues}
        onChange={(selectedValues) => {
          if (selectedValues.length) {
            onSet(selectedValues.map(o => String(o.value)));
          } else {
            onSet([]);
          }
        }}
        testId={testId}
      />
    </FilterPanel>
  );
};

export default IgnoreReasonFilter;
